import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ClubProject } from '../../entities/club-project';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ClubProjectService {

  private static readonly clubProjectBaseUrl:string = `${Settings.apiUrl}/v1/ClubProjects`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getClubProjects(clubId:string, fiscalYearId:number):Promise<ClubProject[]>{

    let oDataBuilder:ODataBuilder = new ODataBuilder(ClubProjectService.clubProjectBaseUrl);

    oDataBuilder
      .filter("ClubId", ODataComparer.Equals, clubId)
      .filter("FiscalYearId", ODataComparer.Equals, fiscalYearId)
      .orderBy("StartDate");

    let clubProjectUrl:string = oDataBuilder.toString();

    return this.http.get(clubProjectUrl)
      .toPromise()
      .then(response => {
          //I'm using "any" and not ClubProject because ClubProject thinks that 
          //StartDate and EndDate are already dates, but they are not yet
          let formattedResponse:any[] = response.json().value;

          formattedResponse.forEach(clubProject => {
            
            if(clubProject.StartDate){
              clubProject.StartDate = DateConverter.convertDate(clubProject.StartDate);
            }
            if(clubProject.EndDate){
              clubProject.EndDate = DateConverter.convertDate(clubProject.EndDate);
            }

          });

          return formattedResponse;
        });
    
  }

  getClubProject(clubProjectId:string):Promise<ClubProject>{
    let clubProjectUrl = `${ClubProjectService.clubProjectBaseUrl}(${clubProjectId})`;

    return this.http.get(clubProjectUrl)
      .toPromise()
      .then(response => {
          //I'm using "any" and not ClubProject because ClubProject thinks that 
          //StartDate and EndDate are already dates, but they are not yet
          let formattedResponse:any = response.json();

          if(formattedResponse.StartDate){
            formattedResponse.StartDate = DateConverter.convertDate(formattedResponse.StartDate);
          }
          if(formattedResponse.EndDate){
            formattedResponse.EndDate = DateConverter.convertDate(formattedResponse.EndDate);
          }

          return formattedResponse;
      });
  }

  saveClubProject(clubProject:ClubProject):Promise<ClubProject>{
    if(clubProject.ClubProjectId){
      return this.putClubProject(clubProject);
    }else{
      return this.postClubProject(clubProject);
    }
  }

  private postClubProject(clubProject:ClubProject):Promise<ClubProject>{
    clubProject.ClubProjectId = "00000000-0000-0000-0000-000000000000";

    return this.http
      .post(ClubProjectService.clubProjectBaseUrl, clubProject)
      .toPromise()
      .then(response => {
            //I'm using "any" and not ClubProject because ClubProject thinks that 
            //StartDate and EndDate are already dates, but they are not yet
            let formattedResponse:any = response.json();

            if(formattedResponse.StartDate){
              formattedResponse.StartDate = DateConverter.convertDate(formattedResponse.StartDate);
            }
            if(formattedResponse.EndDate){
              formattedResponse.EndDate = DateConverter.convertDate(formattedResponse.EndDate);
            }

            return formattedResponse;
          });
  }
  
  private putClubProject(clubProject:ClubProject):Promise<ClubProject>{
    let clubProjectUrl = `${ClubProjectService.clubProjectBaseUrl}(${clubProject.ClubProjectId})`;

    return this.http
      .put(clubProjectUrl, clubProject)
      .toPromise()
      .then(response => clubProject);
  }
  
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/club-project.service.ts